import { COUPON_FETCH_REQUEST, COUPON_FETCH_SUCCESS, COUPON_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    coupon: {},
    error: ''
}

const coupon = (state = initialState, action) => {
    switch (action.type) {
        case COUPON_FETCH_REQUEST:
            return {
                loading: true,
                coupon: {},
                error: '',
            }
        case COUPON_FETCH_SUCCESS:
            return {
                loading: false,
                coupon: action.payload,
                error: ''
            }
        case COUPON_FETCH_FAILURE:
            return {
                loading: false,
                coupon: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default coupon;